import React from 'react';
import './nameHld.css'

function C2wSuperxProjectCardNameHld( {nameHead=null, name=null} ) {
  return (
    <div className='C2wSuperxProjectCardNameHld_ctn'>
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.0013 18.8346C14.6037 18.8346 18.3346 15.1037 18.3346 10.5013C18.3346 5.89893 14.6037 2.16797 10.0013 2.16797C5.39893 2.16797 1.66797 5.89893 1.66797 10.5013C1.66797 15.1037 5.39893 18.8346 10.0013 18.8346Z" stroke="#FFCC00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14 7.5L8.5 13L6 10.5" stroke="#FFCC00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div className='C2wSuperxProjectCardNameHld_name'>
            <div className='C2wSuperxProjectCardNameHld_subheading'>{nameHead}</div>
            <div className='C2wSuperxProjectCardNameHld_subCont'>{name}</div>
        </div>
    </div>
  )
}

export default C2wSuperxProjectCardNameHld
